import { defineFeature } from '@/lib/platform/system';
import { scheduleMachine } from '@/features/schedule/state/schedule.machine';
import { selectionMachine } from '@/features/selection/state/selection.machine';
export const features = [
  defineFeature({
    id: 'schedule',
    machine: scheduleMachine,
    emits: ['schedule.published'],
    handles: [],
    accepts: ['schedule.load-available', 'schedule.publish'],
  }),
  defineFeature({
    id: 'selection',
    machine: selectionMachine,
    emits: ['selection.chosen'],
    handles: ['schedule.published'],
    accepts: ['selection.load-next', 'selection.load-refresh', 'selection.choose'],
  }),
] as const;
